new ScrollHint('.js-scrollable', {
    i18n: {
        scrollable: 'スクロールできます'
    }
});
